export default class OfflineActionHandler {

    private static callback: (action: string) => void | undefined;

    public static setHandler(callback: (action: string) => void | undefined): void {
        this.callback = callback;
    }

    public static handle(action: string): void {
        if (this.callback) this.callback(action);
    }

}
